import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ToolTip from "../tooltip";
import SvgIcon from "../SvgIcon";
import useClickOutside from "../../hooks/useClickOutside";

const LibraryCycleProgram = (props) => {
  const {
    program,
    programIndex,
    cycle,
    cardIndex,
    isPremium,
    isAdmin,
    isAmbassador,
  } = props;
  const { t } = useTranslation("coaching-portal");
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      setShowOptions(false);
    },
    showOptions
  );
  const progressStyles = {
    "In Progress": "inprogress",
    Upcoming: "upcoming",
    Completed: "completed",
  };

  const suggestUpradePath = "/actions/refresh?modal[type]=suggest-upgrade";
  const addToCalendarPath = `/actions/refresh?modal[type]=add-to-calendar&cycleId=${cycle._id}&wholeCycle=false&program=${program.order}`;
  const previewPath = `/dashboard/program-library/program-preview/${
    cycle._id
  }?&program=${programIndex + 1}`;
  const handleOptions = (e) => {
    e.preventDefault();
    setShowOptions(!showOptions);
  };
  return (
    <li className="tr-Cycle-Program-Item" data-order={programIndex}>
      {/* <div className="number">{programIndex + 1}</div> */}
      <div className="tr-content">
        <div className="tr-number">
          <span>
            {program.order}/{cycle.programs.length}
          </span>
        </div>
        <div className="tr-title">{program.name}</div>
      </div>
      <div className="tr-icon-group">
        <details ref={dropdownRef} role="list" open data-align-right>
          <summary onClick={handleOptions}>
            <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
          </summary>
          <ul role="listbox" className={showOptions ? "opened" : ""}>
            {/* <li>
              <a href={previewPath} onClick={() => setShowOptions(false)}>
                <div className="preview">
                  <SvgIcon src="/img/new-icons/eye.svg" alt="" />
                  Preview program
                </div>
              </a>
            </li> */}
            <li>
              <a
                href={
                  cycle.type === "premium" &&
                  !isPremium &&
                  !isAdmin &&
                  !isAmbassador
                    ? suggestUpradePath
                    : addToCalendarPath
                }
                onClick={() => setShowOptions(false)}
              >
                <SvgIcon src="/img/new-icons/calendar-ico.svg" alt="" />
                {t("libraryCycleProgram.addToCalendar")}
              </a>
            </li>
          </ul>
        </details>
      </div>
    </li>
  );
};

export default LibraryCycleProgram;
